<template>
  <!-- 合作院校 -->
  <div class="rightbox backwhite width86 border-rd3" style="min-height: 800px">
    <div class="toolbtn flex margin-right10">
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>
    <el-skeleton class="width100" :loading="true" animated :throttle="200">
      <template slot="template">
        <p
          class="
            flex-betweennowrap
            width98
            margin-auto margin-top20 margin-bot10
          "
        >
          <span class="dimensional">产学研合作</span>
          <span class="attention f14" @click="tocollectionadd()">新 增</span>
        </p>

        <el-table
          :data="page"
          stripe
          class="eltable width98 margin-auto f14"
          v-if="total != 0"
        >
          <el-table-column label="院校/机构名" align="left">
            <template slot-scope="scope">
              <span
                class="width100 cursorpointer bluecolor"
                @click="previewreport(scope.row)"
                >{{ scope.row.title }}
              </span></template
            >
          </el-table-column>
          <el-table-column label="合作主题" align="center" prop="subject" />
          <el-table-column label="合作起止时间" align="center">
            <template slot-scope="scope">
              {{ scope.row.start_at }} 至 {{ scope.row.end_at }}</template
            ></el-table-column
          >
          <el-table-column label="所在地" align="center" prop="address" />
          <el-table-column label="院校联系人" align="center" prop="contact" />
          <el-table-column label="联系电话" align="center" prop="phone" />
          <el-table-column
            label="操作"
            align="center"
            class-name="small-padding fixed-width"
          >
            <template slot-scope="scope">
              <div class="cursorpointer flex">
                <span class="bluecolor" @click="previewreport(scope.row)"
                  >详情</span
                >
                <span
                  class="pad-left20 bluecolor"
                  @click="collectionmodify(scope.row)"
                  >修改</span
                >
                <span
                  class="pad-left20 bluecolor"
                  @click="designDetail(scope.row)"
                  >删除</span
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div
          class="
            flex-betweennowrap
            width98
            margin-auto
            pad-top20 pad-bot20 pad-left10 pad-right10
          "
          v-if="total != 0"
        >
          <span class="f14" style="color: #409eff"></span>
          <el-pagination
            :hide-on-single-page="true"
            @size-change="handleSizeChange"
            @current-change="currentchange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="per_page"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
          >
          </el-pagination>
        </div>
        <div
          class="width100 margin-auto backgroudFFF margin-top15"
          v-if="total == 0"
        >
          <el-empty
            :image="require('@/assets/barsvg/zwsj@3x.png')"
            :image-size="200"
            description="抱歉，没有搜到您想要的内容"
            class="heightempty"
            ><p style="position: relative; bottom: 60px" class="f14">
              暂无数据
            </p></el-empty
          >
        </div>
      </template>
    </el-skeleton>

    <!-- 详情 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisibledetail"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="errorbox"
    >
      <div class="f16 width98 textalign-left dimensional">合作院校</div>
      <div class="margon-auto margin-top30">
        <div class="table">
          <div class="leftboxs">院校名称 :</div>
          <div class="rightboxs">{{ title }}</div>
        </div>
        <div class="table">
          <div class="leftboxs">合作主题 :</div>
          <div class="rightboxs">{{ subject }}</div>
        </div>
        <div class="table">
          <div class="leftboxs">院校地址 :</div>
          <div class="rightboxs">{{ address }}</div>
        </div>
        <div class="table">
          <div class="leftboxs">开始时间 :</div>
          <div class="rightboxs">{{ start_at.substring(0, 10) }}</div>
        </div>
        <div class="table">
          <div class="leftboxs">结束时间 :</div>
          <div class="rightboxs">
            {{ end_at == null ? "" : end_at.substring(0, 10) }}
          </div>
        </div>
        <div class="table">
          <div class="leftboxs">联系人 :</div>
          <div class="rightboxs">{{ contact }}</div>
        </div>
        <div class="table">
          <div class="leftboxs">联系电话 :</div>
          <div class="rightboxs">{{ phone }}</div>
        </div>
        <div class="table">
          <div class="leftboxs">备注 :</div>
          <div class="rightboxs">{{ remark }}</div>
        </div>
      </div>
      <div class="textalign-right margin-top20">
        <el-button @click="dialogVisibledetail = false">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 新增 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisibleadd"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="errorboxs"
    >
      <div class="f16 width98 textalign-left dimensional">合作院校新增</div>
      <div class="pad-top30">
        <div class="bg-box">
          <div>院校名称</div>
          <div class="box-right">
            <el-input
              class="inputDeep"
              placeholder="请输入院校名称"
              v-model="title"
            />
          </div>
        </div>
        <div class="bg-box">
          <div>合作主题</div>
          <div class="box-right">
            <el-input
              class="inputDeep"
              placeholder="请输入合作主题"
              v-model="subject"
            />
          </div>
        </div>
        <div class="bg-box">
          <div>合作开始时间</div>
          <div class="box-right">
            <el-date-picker
              class="inputDeep"
              v-model="start_at"
              type="date"
              placeholder="请选择合作开始时间"
              value-format="yyyy-MM-dd"
              :editable="false"
            ></el-date-picker>
          </div>
        </div>
        <div class="bg-box">
          <div>合作结束时间</div>
          <div class="box-right">
            <el-date-picker
              class="inputDeep"
              v-model="end_at"
              type="date"
              placeholder="请选择合作结束时间"
              value-format="yyyy-MM-dd"
              :editable="false"
            ></el-date-picker>
          </div>
        </div>
        <div class="bg-box">
          <div>院校地址</div>
          <div class="box-right">
            <el-input
              class="inputDeep"
              placeholder="请输入院校地址"
              v-model="address"
            />
          </div>
        </div>

        <div class="bg-box">
          <div>联系人</div>
          <div class="box-right">
            <el-input
              class="inputDeep"
              placeholder="请输入联系人"
              v-model="contact"
            />
          </div>
        </div>
        <div class="bg-box">
          <div>联系电话</div>
          <div class="box-right">
            <el-input
              class="inputDeep"
              placeholder="请输入联系电话"
              v-model="phone"
            />
          </div>
        </div>
        <div class="bg-box">
          <div>备注</div>

          <div class="box-right">
            <el-input
              placeholder="请输入项目备注"
              v-model="remark"
              type="textarea"
              :autosize="autosize"
              class="inputDeep"
              maxlength="500"
              @input="monitorInputs"
              rows="5"
              cols="20"
            >
            </el-input>
            <span class="numLimits">{{ nums }}/200</span>
          </div>
        </div>
      </div>
      <div class="textalign-right margin-top20">
        <el-button @click="dialogVisibleadd = false">取 消</el-button>
        <el-button type="primary" @click="Savechanges()"> 确 定 </el-button>
      </div>
    </el-dialog>
    <!-- 修改 -->

    <el-dialog
      title=""
      :visible.sync="dialogVisiblemodify"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="errorboxs"
    >
      <div class="f16 width98 textalign-left dimensional">合作院校修改</div>
      <div class="pad-top30">
        <div class="bg-box">
          <div>院校名称</div>
          <div class="box-right">
            <el-input
              class="inputDeep"
              placeholder="请输入院校名称"
              v-model="title"
            />
          </div>
        </div>
        <div class="bg-box">
          <div>合作主题</div>
          <div class="box-right">
            <el-input
              class="inputDeep"
              placeholder="请输入合作主题"
              v-model="subject"
            />
          </div>
        </div>
        <div class="bg-box">
          <div>合作开始时间</div>
          <div class="box-right">
            <el-date-picker
              class="inputDeep"
              v-model="start_at"
              type="date"
              placeholder="请选择合作开始时间"
              value-format="yyyy-MM-dd"
              :editable="false"
            ></el-date-picker>
          </div>
        </div>
        <div class="bg-box">
          <div>合作结束时间</div>
          <div class="box-right">
            <el-date-picker
              class="inputDeep"
              v-model="end_at"
              type="date"
              placeholder="请选择合作结束时间"
              value-format="yyyy-MM-dd"
              :editable="false"
            ></el-date-picker>
          </div>
        </div>
        <div class="bg-box">
          <div>院校地址</div>
          <div class="box-right">
            <el-input
              class="inputDeep"
              placeholder="请输入院校地址"
              v-model="address"
            />
          </div>
        </div>

        <div class="bg-box">
          <div>联系人</div>
          <div class="box-right">
            <el-input
              class="inputDeep"
              placeholder="请输入联系人"
              v-model="contact"
            />
          </div>
        </div>
        <div class="bg-box">
          <div>联系电话</div>
          <div class="box-right">
            <el-input
              class="inputDeep"
              placeholder="请输入联系电话"
              v-model="phone"
            />
          </div>
        </div>
        <div class="bg-box">
          <div>备注</div>

          <div class="box-right">
            <el-input
              placeholder="请输入项目备注"
              v-model="remark"
              type="textarea"
              :autosize="autosize"
              class="inputDeep"
              maxlength="500"
              @input="monitorInputs"
              rows="5"
              cols="20"
            />
            <span class="numLimits">{{ nums }}/200</span>
          </div>
        </div>
      </div>
      <div class="textalign-right margin-top20">
        <el-button @click="dialogVisiblemodify = false">取 消</el-button>
        <el-button class="" type="primary" @click="Savechangemodify()">
          确 定
        </el-button>
      </div>
    </el-dialog>
    <!-- 错误弹窗 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  entpartnerschoolsindex,
  entpartnerschoolsdelete,
  entpartnerschoolsdetail,
  entpartnerschoolssave,
  entpartnerschoolsupdate,
} from "@/api/business/business.api";
import callback from "@/components/callback.vue";
export default {
  data() {
    return {
      autosize: {
        minRows: 3,
        maxRows: 1000,
      },
      errormessage: "",
      dialogVisiblenull: false,
      page: [],
      total: 0,
      per_page: 0,
      currentPage: 1,
      dialogVisibledetail: false,
      title: "",
      subject: "",
      remark: "",
      start_at: "",
      end_at: "",
      contact: "",
      phone: "",
      address: "",
      nums: 200,
      dialogVisibleadd: false,
      dialogVisiblemodify: false,
      modifyid: "",
    };
  },
  components: {
    callback,
  },
  methods: {
    monitorInputs() {
      var txtVal = this.remark.length;
      this.nums = txtVal;
    },

    // 详情
    previewreport(row) {
      this.dialogVisibledetail = true;
      entpartnerschoolsdetail({
        id: row.id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.title = res.data.data.title;
          this.subject = res.data.data.subject;
          this.contact = res.data.data.contact;
          this.phone = res.data.data.phone;
          this.remark = res.data.data.remark;
          this.start_at = res.data.data.start_at;
          this.end_at = res.data.data.end_at;
          this.address = res.data.data.address;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 新增
    tocollectionadd() {
      this.dialogVisibleadd = true;
      this.title = "";
      this.subject = "";
      this.contact = "";
      this.phone = "";
      this.remark = "";
      this.start_at = "";
      this.end_at = "";
      this.address = "";
      this.nums = 200;
    },
    Savechanges() {
      entpartnerschoolssave({
        title: this.title,
        subject: this.subject,
        contact: this.contact,
        phone: this.phone,
        remark: this.remark,
        start_at: this.start_at,
        end_at: this.end_at,
        address: this.address,
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
          this.dialogVisibleadd = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 修改
    collectionmodify(row) {
      this.dialogVisiblemodify = true;
      this.modifyid = row.id;
      entpartnerschoolsdetail({
        id: row.id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.title = res.data.data.title;
          this.subject = res.data.data.subject;
          this.contact = res.data.data.contact;
          this.phone = res.data.data.phone;
          this.remark = res.data.data.remark;
          this.nums = 200 - this.remark.length;
          this.start_at = res.data.data.start_at;
          this.end_at = res.data.data.end_at;
          this.address = res.data.data.address;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    Savechangemodify() {
      entpartnerschoolsupdate({
        id: this.modifyid,
        subject: this.subject,
        title: this.title,
        contact: this.contact,
        phone: this.phone,
        remark: this.remark,
        start_at: this.start_at,
        end_at: this.end_at,
        address: this.address,
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
          this.dialogVisiblemodify = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      }); // 失败
    },
    // 删除项目
    designDetail(row) {
      this.$confirm("此操作将删除此项目, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          entpartnerschoolsdelete({ id: row.id }).then((res) => {
            this.refresh();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 第一个分页
    currentchange(val) {
      this.thisNum = val;
      entpartnerschoolsindex({ page: val }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      entpartnerschoolsindex({ page: 1, limit: val }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    refresh() {
      this.$loading.show(); // 显示loading
      entpartnerschoolsindex({ page: this.thisNum }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.$loading.hide(); // 隐藏loading
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
          this.$loading.hide(); // 隐藏loading
        }
      });
    },
  },
  created() {
    entpartnerschoolsindex({ page: this.thisNum }).then((res) => {
      if (res.data.code == 200) {
        this.page = res.data.data.data;
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
<style scoped>
.table {
  width: 98%;
  display: flex;
  margin: auto;
  text-align: left;
  font-size: 14px;
  color: #4f4f4f;
  line-height: 40px;
}
.leftboxs {
  min-width: 70px;
  color: #353a44;
  padding: 0 0 0 5px;
}
.rightboxs {
  margin-left: 10px;
  color: #6a7589;
  padding: 0 0 0 5px;
}

/* 表单盒子 */
.bg-box {
  width: 100%;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 10px 0 10px 0;
  color: #4f4f4f;
  font-size: 14px;
}
.inputDeep {
  width: 100%;
}
.box-right {
  padding-top: 5px;
  width: 100%;
  position: relative;
}
.el-select {
  width: 100%;
}
.el-input-number--small {
  width: 100%;
}
.textarea {
  width: 170%;
  height: 80px;
  border: 1px solid #efefef;
  outline: none;
  padding: 10px 0 0 5px;
}

.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorboxs >>> .el-dialog__header {
  text-align: left;
}
.errorboxs >>> .el-dialog__title {
  text-align: left;
  font-size: 16px;
  color: #606266;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 10%;
}
.eltable >>> .el-table__header-wrapper th {
  background-color: #f1f3f9;
  height: 40px;
  font-size: 14px;
  border-radius: 3px;
}
</style>